import { render, staticRenderFns } from "./ErroPadrao.vue?vue&type=template&id=ff5e78ec&"
import script from "./ErroPadrao.vue?vue&type=script&lang=js&"
export * from "./ErroPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports